<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12" class="mb-3">
      <PageTitle title="Contatos e redes sociais" />
    </b-col>
    <b-col cols="12">
      <b-row
        v-for="(socialMedia, index) in socialMedias"
        :key="index"
        class="mb-4"
      >
        <b-col cols="12" class="mb-1">
          <i :class="socialMedia.logo"></i>
          <span class="ml-2">{{ socialMedia.name }}</span>
        </b-col>
        <b-col cols="12">
          <input
            v-if="
              fields[socialMedia.key].type === SOCIAL_MEDIAS.TELEPHONE ||
              fields[socialMedia.key].type === SOCIAL_MEDIAS.WHATSAPP
            "
            type="text"
            v-model="fields[socialMedia.key].url"
            v-mask="['(##) #####-####', '(##) ####-####']"
            class="form-control"
          />
          <input
            v-else
            type="text"
            v-model="fields[socialMedia.key].url"
            class="form-control"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="mb-2">
          <b-button block variant="success" @click="save()">
            <i class="fas fa-save mr-2"></i>
            Salvar
          </b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SOCIAL_MEDIAS from 'Enums/SocialMedias.js';
import makeToast from '@/mixins/makeToast';

import PageTitle from '@/components/PageTitle.vue';

export default {
  name: 'CustomizationSocialMedias',
  components: { PageTitle },
  mixins: [makeToast],
  data() {
    return {
      SOCIAL_MEDIAS,
      loading: false,
      companyInfo: {},
      fields: {
        instagram: {
          id: 0,
          url: '',
          type: 'instagram',
        },
        facebook: {
          id: 0,
          url: '',
          type: 'facebook',
        },
        whatsapp: {
          id: 0,
          url: '',
          type: 'whatsapp',
        },
        twitter: {
          id: 0,
          url: '',
          type: 'twitter',
        },
        youtube: {
          id: 0,
          url: '',
          type: 'youtube',
        },
        tiktok: {
          id: 0,
          url: '',
          type: 'tiktok',
        },
      },
      socialMedias: [
        {
          key: 'instagram',
          logo: 'fab fa-instagram',
          name: 'Link Instagram',
          type: SOCIAL_MEDIAS.INSTAGRAM,
        },
        {
          key: 'facebook',
          logo: 'fab fa-facebook',
          name: 'Link Facebook',
          type: SOCIAL_MEDIAS.FACEBOOK,
        },
        {
          key: 'whatsapp',
          logo: 'fab fa-whatsapp',
          name: 'Número do Whatsapp',
          type: SOCIAL_MEDIAS.WHATSAPP,
        },
        {
          key: 'twitter',
          logo: 'fab fa-twitter',
          name: 'Link Twitter',
          type: SOCIAL_MEDIAS.TWITTER,
        },
        {
          key: 'youtube',
          logo: 'fab fa-youtube',
          name: 'Link Youtube',
          type: SOCIAL_MEDIAS.YOUTUBE,
        },
        {
          key: 'tiktok',
          logo: 'fab fa-tiktok',
          name: 'Link TikTok',
          type: SOCIAL_MEDIAS.TIKTOK,
        },
      ],
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    validSocialMedias() {
      const socialMedias = [];

      Object.keys(this.fields).forEach((key) => {
        if (!this.fields[key].url) return;

        socialMedias.push(this.fields[key]);
      });
      return socialMedias;
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    ...mapActions('professional', ['saveSocialMedias', 'getSocialMedias']),
    get() {
      this.loading = true;
      this.$store.dispatch('startLoader');

      this.getSocialMedias(this.dadosUsuario.informacoes.id)
        .then((response) => {
          if (!response.data.data || !response.data.data.length) return;

          response.data.data.forEach((socialMedia) => {
            Object.keys(this.fields).forEach((key) => {
              if (this.fields[key].type !== socialMedia.type) return;

              this.fields[key] = {
                id: socialMedia.id,
                url: socialMedia.url,
                type: socialMedia.type,
              };
            });
          });
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer as redes sociais',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    save() {
      const request = {
        professionalId: this.dadosUsuario.informacoes.id,
        socialMedias: [],
      };

      Object.keys(this.fields).forEach((key) => {
        request.socialMedias.push({
          name: key,
          id: this.fields[key].id,
          type: this.fields[key].type,
          url: this.fields[key].url,
        });
      });

      this.$store.dispatch('startLoader');

      this.saveSocialMedias(request)
        .then(() => {
          this.makeToast(
            'Sucesso',
            'Contato e redes sociais salvas com sucesso'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
  },
};
</script>

<style scoped>
.imgWidget {
  width: 300px;
}
</style>
